// Login.js
import { auth } from "./firebase";
import { GoogleAuthProvider, signInWithPopup, signInWithRedirect } from "firebase/auth";

const provider = new GoogleAuthProvider();

function Login({ staffOnly }) {
  const handleSignIn = async () => {
    try {
      await signInWithPopup(auth, provider);
    } catch (err) {
      // Safari blocks popups — fall back to redirect
      if (err.code === "auth/popup-blocked" || err.code === "auth/popup-closed-by-user") {
        await signInWithRedirect(auth, provider);
      } else {
        console.error("Sign-in error:", err);
      }
    }
  };

  return (
    <div style={{
      background: "#1a0a12",
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "1.5rem",
    }}>
      <h1 style={{ color: "#fcb31f", margin: 0 }}>🎟 Golden Ticket</h1>
      {staffOnly && (
        <p style={{ color: "#e74c3c", margin: 0, textAlign: "center", fontSize: "0.9rem" }}>
          This device is for staff only.
        </p>
      )}
      <button
        onClick={handleSignIn}
        style={{
          background: "white",
          color: "#1a0a12",
          border: "none",
          borderRadius: "8px",
          padding: "0.75rem 1.5rem",
          fontSize: "1rem",
          fontWeight: "bold",
          cursor: "pointer",
        }}
      >
        Sign in with Google
      </button>
      <button
        onClick={() => window.history.back()}
        style={{ background: "none", border: "none", color: "rgba(255,255,255,0.35)", fontSize: "0.8rem", cursor: "pointer", padding: 0 }}
      >
        ← Back
      </button>
    </div>
  );
}

export default Login;